import icons from '../../img/icons.svg';
import view from './view';

class bookmarksView extends view {
  _parentElement = document.querySelector('.bookmarks__list');
  _data;
  _errorMessage = '<p>No bookmarks yet!</p>';
  _message = '<p>Start by searching for a recipe or an ingredient!</p>';

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }
  //   _generateMarkup() {
  //     const id = window.location.hash.slice(1);
  //     return `
  //     ${this._data
  //       .map(rec => {
  //         return `
  //         <li class="preview">
  //             <a class="preview__link ${
  //               id === rec.id ? 'preview__link--active' : ''
  //             }" href="#${rec.id}">
  //               <figure class="preview__fig">
  //                 <img src="${rec.image}" alt="Test" />
  //               </figure>
  //               <div class="preview__data">
  //                 <h4 class="preview__title">${rec.title}</h4>
  //                 <p class="preview__publisher">${rec.publisher}</p>
  //               </div>
  //             </a>
  //           </li>`;
  //       })
  //       .join('')}
  //     `;
  //   }
}

export default new bookmarksView();
